export { ErrorBoundary } from 'react-error-boundary';

type ErrorEvent = {
    errors?: Array<{ errorClass?: string; errorMessage?: string }>;
};

export const isValidationError = (event: ErrorEvent): boolean => {
    const errors = Array.from(event?.errors ?? []);
    return errors.some((err) => {
        return err.errorClass === 'ValidationError';
    });
};

export const isResizeObserverError = (event: ErrorEvent): boolean => {
    const errors = Array.from(event?.errors ?? []);

    return errors.some((err) => {
        if (err?.errorClass?.includes('ResizeObserver')) {
            return true;
        }

        const message = String(err?.errorMessage ?? '').trim();

        return message.includes('ResizeObserver'.trim());
    });
};

export const LogError = (error: unknown) => {
    const userJson = localStorage.getItem('user');
    let user: { id?: string } | null = null;
    try {
        user = userJson ? JSON.parse(userJson) : null;
    } catch {
        user = null;
    }

    if (user) {
        const { id } = user;
        console.error({ error, userId: id });
    } else {
        console.error({ error, userId: undefined });
    }
};
